import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";

const TOKEN_KEY = "famfeel_admin_token";

export default function AdminLogin() {
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (sessionStorage.getItem(TOKEN_KEY)) {
      navigate("/admin/dashboard", { replace: true });
    }
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    if (!password) return;
    setBusy(true);
    try {
      const { token } = await api.adminLogin(password);
      sessionStorage.setItem(TOKEN_KEY, token);
      navigate("/admin/dashboard", { replace: true });
    } catch (err) {
      const status = err?.response?.status;
      if (status === 401) toast.error("Wrong password");
      else if (status === 429) toast.error("Too many attempts");
      else toast.error("Couldn't log in");
      setPassword("");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[color:var(--bg,#F5EFE2)] flex items-center justify-center px-6">
      <form
        onSubmit={submit}
        className="w-full max-w-sm bg-[color:var(--surface)] rounded-xl border border-[color:var(--line)] p-6 space-y-4"
        data-testid="admin-login-form"
      >
        <div>
          <div className="label-tiny">FamFeel · internal</div>
          <h1 className="font-display-italic text-4xl tracking-tight mt-1">Admin</h1>
        </div>
        <input
          type="password"
          autoFocus
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full border border-[color:var(--line)] rounded-xl px-4 py-3 font-mono focus:outline-none focus:border-[color:var(--ink)]"
          data-testid="admin-password-input"
        />
        <button
          type="submit"
          disabled={busy || !password}
          className="ff-btn ff-btn-primary w-full disabled:opacity-60"
          data-testid="admin-submit"
        >
          {busy ? "Checking…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
